import { trackMiscAction, trackSceneAction } from 'analytics';
import FrameProperties from '../FrameProperties';
import ShareSceneModal from 'components/Modal/Share/ShareSceneModal';
import ShareFrameModal from 'components/Modal/Share/ShareFrameModal';
import Button, { ButtonType } from 'components/Widget/Button/Button';
import CtaButton from 'components/Widget/Button/CtaButton';
import { MenuItemAction } from 'menu/MenuItem';
import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectActiveScene, selectUser } from 'redux/db/reducers';
import { setRightPanelWidth } from 'redux/mode/actions';
import { getSelectedFrameId } from 'redux/mode/util';
import { RootReducer, selectSelectedFrames } from 'redux/reducers';
import MultipleFrameProperties from '../MultipleFrameProperties';
import ResizablePanel from '../ResizablePanel';
import SceneProperties from '../SceneProperties';
import * as Base from '../styles';
import ProjectName from './ProjectName';
import * as S from './styles';
import ZoomMenuButton from './ZoomMenuButton';

const RightPanel = () => {
	const dispatch = useDispatch();
	const [showShareSceneModal, setShowShareSceneModal] = useState(false);
	const [showShareFrameModal, setShowShareFrameModal] = useState(false);
	const { scene, rightPanelWidth, selected, selectedFrames, user } = useSelector(
		(r: RootReducer) => {
			return {
				scene: selectActiveScene(r.db, r.mode.activeSceneId),
				rightPanelWidth: r.mode.rightPanelWidth,
				selected: r.mode.selected,
				selectedFrames: selectSelectedFrames(r),
				user: selectUser(r.db),
			};
		},
		shallowEqual
	);
	const title = scene?.title;
	const selectedFrameId = getSelectedFrameId(selected);
	const isOneFrameSelected = selectedFrames.length === 1;

	// we used to show the learning center button here but i removed it -- the learning center is no longer up-to-date
	// for now let's use the same placement to show our CTA button
	const showCtaButton = user?.id === 'guest';

	const headerMenuItems = scene ? [MenuItemAction.createRenameScene(scene)] : [];

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	const renderContents = () => {
		if (selectedFrames.length === 1) {
			return <FrameProperties frame={selectedFrames[0]} />;
		}
		if (selectedFrames.length > 1) {
			return <MultipleFrameProperties frames={selectedFrames} />;
		}
		if (selected.length === 0) {
			if (scene) {
				return <SceneProperties scene={scene} />;
			}
			return null;
		}
	};

	return (
		<ResizablePanel
			resizeOnSide="left"
			size={rightPanelWidth}
			onResize={(w) => dispatch(setRightPanelWidth(w))}
		>
			<Base.Base>
				{/* always show a top section the zoom amount (perhaps later more info goes here) */}
				<S.Top>
					<ZoomMenuButton />
					{title && <ProjectName label={title} menuItems={headerMenuItems} />}
					<S.Spacer />
					<S.ButtonWrapper>
						{scene && rightPanelWidth > 120 && (
							<Button
								width={104}
								onSelected={() => {
									if (isOneFrameSelected) {
										trackMiscAction('open_frame_share_modal');
										setShowShareFrameModal(true);
									} else {
										trackSceneAction('open_share_modal');
										setShowShareSceneModal(true);
									}
								}}
								type={ButtonType.NOTICEABLE}
							>
								{isOneFrameSelected ? 'Share frame' : 'Share project'}
							</Button>
						)}
					</S.ButtonWrapper>
				</S.Top>
				{renderContents()}
				{showCtaButton && (
					<>
						<Base.Divider />
						<S.FooterButton>
							<CtaButton minimal={rightPanelWidth < 200} />
						</S.FooterButton>
					</>
				)}
			</Base.Base>
			{showShareSceneModal && scene && (
				<ShareSceneModal scene={scene} onClose={() => setShowShareSceneModal(false)} />
			)}
			{showShareFrameModal && selectedFrameId && (
				<ShareFrameModal frameId={selectedFrameId} onClose={() => setShowShareFrameModal(false)} />
			)}
		</ResizablePanel>
	);
};

export default RightPanel;
